import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslations } from "@jti/ui";
export const SummaryCartItemsGiftBadge = ({ className }) => {
    const { __ } = useTranslations();
    return (_jsx("div", { className: className, children: _jsx("span", { children: __("cart.payment_summary.freeGift") }) }));
};
//# sourceMappingURL=SummaryCartItemsGiftsBadge.js.map